// Product gallery follows the selected variant.
// Reads script[data-variant-media]: entries of [variantId, featuredMediaId, variantTag].
// - Default: the selected variant's own photo moves to the front of the gallery.
// - With data-variant-gallery (photos tagged by variant name in their alt text): only the selected
//   variant's photos stay visible, its own photo first; untagged photos are hidden once a variant is chosen.
// Listens for option changes from <s-variant-picker>, which carry the variant id on the input or option.
const mapEl = document.querySelector('script[data-variant-media]');
const gallery = document.querySelector('[data-product-gallery]');

if (mapEl && gallery) {
  let entries = [];
  try {
    entries = JSON.parse(mapEl.textContent || '[]') || [];
  } catch {
    entries = [];
  }
  const variants = new Map(
    entries.filter(Array.isArray).map(([id, mediaId, tag]) => [String(id), { mediaId: String(mediaId || ''), tag: tag || '' }]),
  );
  const filterByVariant = mapEl.hasAttribute('data-variant-gallery');

  const show = (variantId) => {
    const variant = variants.get(String(variantId));
    if (!variant) return;
    const items = gallery.querySelectorAll('[data-media-id]');
    const target = variant.mediaId ? gallery.querySelector(`[data-media-id="${variant.mediaId}"]`) : null;
    if (!target && !filterByVariant) return;

    items.forEach((item) => {
      const isTarget = item === target;
      item.style.order = isTarget ? '-1' : '';
      if (filterByVariant) {
        const belongs = isTarget || (variant.tag && (item.dataset.mediaTag || '').includes(variant.tag));
        item.style.display = belongs ? '' : 'none';
        if (!belongs) item.querySelectorAll('video').forEach((video) => video.pause());
      }
    });

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Mobile: the gallery scrolls sideways, so return it to the first slide.
    gallery.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    // Desktop: if the gallery top is off screen, bring the photo into view.
    const rect = gallery.getBoundingClientRect();
    if (rect.top < 0 && window.matchMedia('(min-width: 768px)').matches) {
      gallery.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  };

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLElement) || !input.closest('s-variant-picker')) return;
    const variantId = input.dataset.variantId || input.selectedOptions?.[0]?.dataset?.variantId;
    if (variantId) show(variantId);
  });
}
